import React, {useRef} from 'react';

import Constants from '../../../common/Constants';
import {LocResourcesProvider} from '../../../common/contexts/LocResourcesContext';
import ErrorHandler from '../../../common/errors/ErrorHandler';
import MetricsService from '../../../common/services/MetricsService';
import keys from '../../utils/locResourcesKeys';

import ShutdownComponent from './ShutdownComponent';
import {Domain, findSiteByDomain} from "@zooplus/commons-lang";
import {getLocale} from "../../../common/utils/locale";

interface ShutdownProps {
  siteDomain: Domain;
  bpEnabled: boolean;
}

const Shutdown = ({
  siteDomain,
  bpEnabled,
}: ShutdownProps): JSX.Element => {
  const metricServiceInstanceRef = useRef<MetricsService>(
    MetricsService.init(Constants.COMPONENT_NAME.REWARD_SHOP, Constants.COMPONENT_LOCATION.REWARD_SHOP, siteDomain)
  );
  const site = findSiteByDomain(siteDomain);
  return (
    <ErrorHandler metricsService={metricServiceInstanceRef.current}>
      <LocResourcesProvider
        metricsService={metricServiceInstanceRef.current}
        locale={getLocale(site)}
        keys={keys}
        siteId={site.id}>
        <ShutdownComponent
          bpEnabled={bpEnabled}
          metricsService={metricServiceInstanceRef.current}
        />
      </LocResourcesProvider>
    </ErrorHandler>
  );
};
export default React.memo(Shutdown);
